import {
    ASSIGN_FIRMWARE_OPEN_MODAL,
    ASSIGN_FIRMWARE_CLOSE_MODAL,
    ASSIGN_FIRMWARE_GET_DEVICE_REQUEST,
    ASSIGN_FIRMWARE_GET_DEVICE_RESULT,
    ASSIGN_FIRMWARE_SET_DEVICE,
    ASSIGN_FIRMWARE_SEARCH_REQUEST,
    ASSIGN_FIRMWARE_SEARCH_RESULT,
    ASSIGN_FIRMWARE_REQUEST,
    ASSIGN_FIRMWARE_RESULT,
    ASSIGN_FIRMWARE_SEARCH_CAMERAS_BY_ACCOUNT,
    ASSIGN_FIRMWARE_SEARCH_CAMERAS_BY_ACCOUNT_RESULT,
    ASSIGN_BULK_FIRMWARE_REQUEST,
    ASSIGN_BULK_FIRMWARE_RESULT,
} from 'Redux/actionTypes';

export const assignFirmwareRequest = (data) => ({
    type: ASSIGN_FIRMWARE_REQUEST,
    payload: data
})

export const assignFirmwareResult = (result) => ({
    type: ASSIGN_FIRMWARE_RESULT,
    payload: result
})

export const assignFirmwareOpenModal = (items) => ({
    type: ASSIGN_FIRMWARE_OPEN_MODAL,
    payload: items
})

export const assignFirmwareCloseModal = () => ({
    type: ASSIGN_FIRMWARE_CLOSE_MODAL
})

export const assignFirmwareGetDeviceRequest = (data) => ({
    type: ASSIGN_FIRMWARE_GET_DEVICE_REQUEST,
    payload: data
})

export const assignFirmwareGetDeviceResult = (result) => ({
    type: ASSIGN_FIRMWARE_GET_DEVICE_RESULT,
    payload: result
})

export const assignFirmwareSetDevices = (items) => ({
    type: ASSIGN_FIRMWARE_SET_DEVICE,
    payload: items
})

export const assignFirmwareSearchRequest = (data) => ({
    type: ASSIGN_FIRMWARE_SEARCH_REQUEST,
    payload: data
})

export const assignFirmwareSearchResult = (result) => ({
    type: ASSIGN_FIRMWARE_SEARCH_RESULT,
    payload: result
})

export const assignFirmwareSearchCamerasByAccountRequest = (data) => ({
    type: ASSIGN_FIRMWARE_SEARCH_CAMERAS_BY_ACCOUNT,
    payload: data
})

export const assignFirmwareSearchCamerasByAccountResult = (data) => ({
    type: ASSIGN_FIRMWARE_SEARCH_CAMERAS_BY_ACCOUNT_RESULT,
    payload: data
})


export const bulkAssignFirmwareRequest = (data) => ({
    type: ASSIGN_BULK_FIRMWARE_REQUEST,
    payload: data
})

export const bulkAssignFirmwareResult = (result) => ({
    type: ASSIGN_BULK_FIRMWARE_RESULT,
    payload: result
})